import React, { Component } from 'react';

import { InsightPriority } from 'common/constants/insights';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsInsightObjectBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The insight object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the insight.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'The user who created the insight, if available.',
                heading: 'author',
                subheading: 'User object (optional)',
              },
              {
                description: 'The company associated with the insight, if available.',
                heading: 'company',
                subheading: 'company object (optional)',
              },
              {
                description: 'Time at which the insight was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: `The priority level of the insight, if set. Possible values are ${Object.values(
                  InsightPriority,
                )
                  .map((priority) => `"${priority}"`)
                  .join(', ')}`,
                heading: 'priority',
                subheading: 'string (optional)',
              },
              {
                description: 'The source of the insight (e.g., "canny", "webhook").',
                heading: 'source',
                subheading: 'Source object',
              },
              {
                description: 'A URL associated with the insight, if available.',
                heading: 'url',
                subheading: 'string (optional)',
              },
              {
                description: 'The users mentioned or associated with the insight.',
                heading: 'users',
                subheading: 'User object[]',
              },
              {
                description: 'The text content of the insight.',
                heading: 'value',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example insight object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1235",
  "author": {
    "id": "553c3ef8b8cdcd1501ba1236",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  },
  "company": {
    "monthlySpend": 1000,
    "name": "Company Name",
    "id": "1234567890",
    "urlName": "company-name"
  },
  "created": "${this.createdAt.toISOString()}",
  "priority": "high",
  "source": {
    "name": "ui",
    "type": "manual"
  },
  "url": null,
  "users": [{
    "id": "553c3ef8b8cdcd1501ba123a",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  }],
  "value": "This is an important insight about the feature."
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
